import { render, staticRenderFns } from "./ModalDialogLayout.vue?vue&type=template&id=55fe63b5&scoped=true"
import script from "./ModalDialogLayout.vue?vue&type=script&lang=js"
export * from "./ModalDialogLayout.vue?vue&type=script&lang=js"
import style0 from "./ModalDialogLayout.vue?vue&type=style&index=0&id=55fe63b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fe63b5",
  null
  
)

export default component.exports